/*!
 * WolfCenter — AJAX add-to-cart for wc-card forms
 * Intercepts <form class="wc-card__form"> submits, posts to /cart/add.js,
 * refreshes the cart-icon-bubble + cart-drawer sections, and opens the drawer.
 *
 * No framework. Plain JS. Compatible with Dawn's <cart-drawer> custom element.
 */
(function () {
  'use strict';

  const SECTIONS_TO_REFRESH = [
    { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' },
    { id: 'cart-drawer', selector: 'cart-drawer' },
  ];

  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('.wc-card__form');
    if (!form) return;

    e.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const originalLabel = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    try {
      // 1. Add the item
      const sectionsParam = SECTIONS_TO_REFRESH.map((s) => s.id).join(',');
      const formData = new FormData(form);
      formData.append('sections', sectionsParam);
      formData.append('sections_url', window.location.pathname);

      const addResponse = await fetch(window.Shopify?.routes?.root + 'cart/add.js' || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });

      if (!addResponse.ok) {
        const err = await addResponse.json().catch(() => ({ description: 'Could not add to cart.' }));
        throw new Error(err.description || err.message || 'Error adding to cart');
      }

      const data = await addResponse.json();

      // 2. Refresh cart sections returned by Shopify
      if (data.sections) {
        SECTIONS_TO_REFRESH.forEach((entry) => {
          const html = data.sections[entry.id];
          if (!html) return;
          const target = document.querySelector(entry.selector);
          if (!target) return;
          // Parse and find the equivalent node inside the returned HTML
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const fresh = doc.querySelector(entry.selector);
          if (fresh) {
            target.innerHTML = fresh.innerHTML;
          }
        });
      }

      // 3. Open the cart drawer if present
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.classList.remove('is-empty');
        drawer.open();
      } else if (drawer && typeof drawer.openDrawer === 'function') {
        drawer.openDrawer();
      } else {
        // Fallback: visual flash on the cart icon
        flashCartIcon();
      }

      // 4. Notify the rest of the theme (Dawn listens for cart:updated)
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      // Also publish on the PubSub bus if Dawn provides it
      if (window.PUB_SUB_EVENTS && window.publish) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'wc-card-form',
          productVariantId: formData.get('id'),
          cartData: data,
        });
      }

      if (button) {
        button.textContent = 'Added ✓';
        setTimeout(() => {
          button.disabled = false;
          button.textContent = originalLabel || 'Add to cart';
        }, 1400);
      }
    } catch (err) {
      console.error('[wc-cart-ajax]', err);
      if (button) {
        button.textContent = 'Try again';
        setTimeout(() => {
          button.disabled = false;
          button.textContent = originalLabel || 'Add to cart';
        }, 1800);
      }
      showToast(err.message || 'Could not add to cart');
    }
  });

  function flashCartIcon() {
    const icon = document.querySelector('#cart-icon-bubble, .header__icon--cart');
    if (!icon) return;
    icon.style.transition = 'transform 0.2s';
    icon.style.transform = 'scale(1.2)';
    setTimeout(() => {
      icon.style.transform = 'scale(1)';
    }, 200);
  }

  function showToast(msg) {
    let toast = document.querySelector('.wc-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wc-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('wc-toast--visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(() => {
      toast.classList.remove('wc-toast--visible');
    }, 3000);
  }
})();
